import { Component, OnInit } from "@angular/core";
import { ZPNotification } from "src/app/models/zpnotification";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { NotificationService } from "src/app/services/notification.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-client-access-page",
    templateUrl: "./client-access-page.component.html",
    styleUrls: ["./client-access-page.component.scss"],
    standalone: false
})
export class ClientAccessPageComponent implements OnInit {
  public professionals: any = [];
  public selectedId;
  public clientAccessPageUrl: string;
  public myUser: any;
  public dataIsLoaded: boolean;
  public isSearching: boolean = false;
  public usersFoundArray: any;
  public usersFound: boolean;
  public message: string;
  public searchData;

  public currentPage: number = 1;
  public totalPages: number;
  public pageSize: number = 20; // Set your desired page size here
  public filter: string = '{"userType":"professional"}';
  public refCodeArray: string[] = [];
  refCodesList: any[] = [];
  selectedItemCode: any;
  public mappedRefCodes: { [key: string]: any } = {};
  public editCache: { [key: string]: { client_access_page: string, advisor_hub: string } } = {};

  constructor(
    private api: ZpDataService,
    private adminApi: AdminDashboardService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private notifications: NotificationService
  ) {}

  async ngOnInit() {
    this.loadPage(this.currentPage);
    this.sideNavBarVisibilityService.changeMessage("top");
  }

  loadPage(page: number) {
    this.api
      .getAllUsers(page, undefined, this.pageSize, this.filter)
      .then(async (result) => {
        this.currentPage = result.page;
        this.totalPages = result.pages;
        this.refCodeArray = [];
        this.refCodesList = [];
        result.users.forEach((professional) => {
          if (professional.license && professional.license.refCode) {
            this.refCodeArray.push(professional.license.refCode);
          }
        });
        await this.getRefCodes();
        this.mapRefCodes();
        this.professionals = result.users;
      });
  }

  async getRefCodes() {
    const refCodeArray = this.refCodeArray;
    const filter = { code: { $in: refCodeArray } };
    this.refCodesList = await this.adminApi.getList(
      "refcodes",
      undefined,
      filter,
      "clientAccessPage"
    );
  }

  mapRefCodes() {
    this.mappedRefCodes = {};

    this.refCodesList.forEach((refCode) => {
      if (!refCode.instructions) {
        refCode.instructions = { client_access_page: ' ', advisor_hub: ' ' };
      }

      // Populate the mappedRefCodes and initialize the editCache
      this.mappedRefCodes[refCode.code] = refCode;
      this.editCache[refCode.code] = { 
        client_access_page: refCode.instructions.client_access_page || ' ',
        advisor_hub: refCode.instructions.advisor_hub || ' '
      };
    });

    console.log(this.mappedRefCodes);
  }

  toggleSection(code) {
    if (this.selectedItemCode === code) {
      this.selectedItemCode = null;
    } else {
      this.selectedItemCode = code;
    }
  }

  async saveItem(refCodeString: string) {
    // Ensure editCache for the given refCodeString exists
    if (!this.editCache[refCodeString]) {
      this.editCache[refCodeString] = { client_access_page: '', advisor_hub: '' };
    }
  
    const editedValues = this.editCache[refCodeString];
    const refCodeObject = this.mappedRefCodes[refCodeString];
  
    // Update only the modified fields in the `instructions` object
    refCodeObject.instructions.client_access_page = editedValues.client_access_page || refCodeObject.instructions.client_access_page;
    refCodeObject.instructions.advisor_hub = editedValues.advisor_hub || refCodeObject.instructions.advisor_hub;
  
    const result = await this.adminApi.putItem("refcodes", refCodeObject);
  
    if (result && result.success) {
      // Update the mappedRefCodes with the latest data
      this.mappedRefCodes[refCodeString].instructions = {
        ...this.mappedRefCodes[refCodeString].instructions,
        ...editedValues, // Only merge the changed values
      };
      this.notifications.changeMessage(new ZPNotification("Item Saved"));
      this.toggleSection(refCodeString);
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"));
    }
  }
  

  async searchByLastName(searchData) {
    this.dataIsLoaded = false;
    this.isSearching = true;
    let jsonData = `{"userType":"professional","lastName":"${searchData}"}`;
    let data = await this.api.getAllUsers(
      undefined,
      undefined,
      undefined,
      jsonData
    );
    this.dataIsLoaded = true;
    if (data.users.length > 0) {
      this.refCodeArray = [];
      this.refCodesList = [];
      data.users.forEach((professional) => {
        if (professional.license && professional.license.refCode) {
          this.refCodeArray.push(professional.license.refCode);
        }
      });
      await this.getRefCodes();
      this.mapRefCodes();
      this.usersFoundArray = data.users;
      this.usersFound = true;
    } else {
      this.usersFound = false;
      this.message = "This user does not exist.";
    }
  }

  backToTable() {
    this.ngOnInit();
    this.isSearching = false;
  }
}
